"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TPSLCloseMode = void 0;
/**设置止盈止损时的平仓模式 */
var TPSLCloseMode;
(function (TPSLCloseMode) {
    /**全平 */
    TPSLCloseMode["CloseAll"] = "CloseAll";
    /**按照数量平仓 */
    TPSLCloseMode["CloseAmount"] = "CloseAmount";
})(TPSLCloseMode = exports.TPSLCloseMode || (exports.TPSLCloseMode = {}));
var TPSLPosition;
(function (TPSLPosition) {
    TPSLPosition["all"] = "all";
    TPSLPosition["part"] = "part";
})(TPSLPosition || (TPSLPosition = {}));
